var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"py-5 bg-white text-center",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"mermaid",attrs:{"id":"mermaid"},domProps:{"innerHTML":_vm._s(_vm.ad.configuration.graph)}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }